// extracted by mini-css-extract-plugin
export var leftAlign = "_32-2";
export var popper = "_32-0";
export var subtitle = "_32-1";